import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/park/blacklist/list', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/park/blacklist/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/park/blacklist/remove', qs.stringify(params), options);

export const add = (params, options) => request.post('/api/park/blacklist/submit', params, options);

export const update = (params, options) =>
  request.post('/api/park/blacklist/submit', params, options);

export const delayBlacklist = (params, options) =>
  request.post('/api/park/blacklist/delay', params, options);

export const submitImportFile = (formData) => {
  return request({
    url: '/api/park/blacklist/import',
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
  });
};

export const syncBlacklist = (params, options) =>
  request.post('/api/park/blacklist/sync', qs.stringify(params), options);

export const addBatch = (params, options) => request.post('/api/park/blacklist/addBatch', params, options);
